'use client';

import { c as _c } from "react/compiler-runtime";
import { useKeenSlider } from 'keen-slider/react';
import { useTopNav } from '@src/components/TopNavV3/TopNavContext';
import { TopNavTile } from '@src/components/TopNavV3/TopNavTile';
import { cn } from '@src/utils/tailwind';
export const TopNavSubMenuTileSlider = () => {
  const $ = _c(21);
  const {
    expandedMenu
  } = useTopNav();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      loop: false,
      mode: "free",
      rubberband: false,
      slides: {
        perView: "auto",
        origin: "auto",
        spacing: 12
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [sliderRef] = useKeenSlider(t0);
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[1] !== expandedMenu?.tiles || $[2] !== sliderRef) {
    t6 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const tiles = (expandedMenu?.tiles ?? []).filter(_temp);
      if (tiles.length === 0) {
        t6 = null;
        break bb0;
      }
      const isSingleTile = tiles.length === 1;
      let t7;
      if ($[9] !== isSingleTile) {
        t7 = () => {
          if (isSingleTile) {
            return null;
          }
          return <div className="keen-slider__slide max-w-1 min-w-1 sm:max-w-5 sm:min-w-5" />;
        };
        $[9] = isSingleTile;
        $[10] = t7;
      } else {
        t7 = $[10];
      }
      const renderSpacer = t7;
      t1 = sliderRef;
      t2 = "keen-slider border-t border-white/10 py-6";
      if ($[11] !== renderSpacer) {
        t3 = renderSpacer();
        $[11] = renderSpacer;
        $[12] = t3;
      } else {
        t3 = $[12];
      }
      let t8;
      if ($[13] !== isSingleTile) {
        t8 = (tile_0, i) => {
          const effectiveMobileColumns = isSingleTile ? 1 : 1.25;
          const width = `${100 / effectiveMobileColumns}%`;
          return <div key={i} className={cn("keen-slider__slide", {
            "px-4": isSingleTile
          })} style={{
            minWidth: width,
            maxWidth: width
          }}><TopNavTile key={i} tile={tile_0} /></div>;
        };
        $[13] = isSingleTile;
        $[14] = t8;
      } else {
        t8 = $[14];
      }
      t4 = tiles.map(t8);
      t5 = renderSpacer();
    }
    $[1] = expandedMenu?.tiles;
    $[2] = sliderRef;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
  }
  if (t6 !== Symbol.for("react.early_return_sentinel")) {
    return t6;
  }
  let t7;
  if ($[15] !== t1 || $[16] !== t2 || $[17] !== t3 || $[18] !== t4 || $[19] !== t5) {
    t7 = <div ref={t1} className={t2}>{t3}{t4}{t5}</div>;
    $[15] = t1;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};
function _temp(tile) {
  return tile.isVisible ?? true;
}